module.exports = "/images/vendor/flag-icon-css/flags/4x3/bt.svg?65b20c56edb0ae6f6523f7242256bf25";